export const LOGIN_MODE = {
  QR: 'QR',
  OTP: 'OTP',
  EMAIL: 'EMAIL',
  ACTIVE_DIRECTORY: 'ACTIVE_DIRECTORY',
}

export const LS_LOGIN_MODE = {
  QR: 0,
  OTP: 1,
  EMAIL: 2,
  ACTIVE_DIRECTORY: 3,
}

export const VIEW_MODE = {
  QR: 'QR',
  OTP: 'OTP',
  EMAIL: 'EMAIL',
  ORG: 'ORG',
  ACTIVE_DIRECTORY: 'ACTIVE_DIRECTORY',
}
